import { Button, Space } from "antd";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { changeLanguage } from "../../i18n";
import { SupportedLanguage, supportedLanguages } from "../../i18n/resources";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const handleChangeLanguage = useCallback((language: SupportedLanguage) => {
    void changeLanguage(language);
  }, []);

  return (
    <Space aria-label={t("language.switchLabel")}>
      {supportedLanguages.map((language) => (
        <Button
          key={language}
          size="small"
          type={i18n.language === language ? "primary" : "default"}
          onClick={() => handleChangeLanguage(language)}
        >
          {language.toUpperCase()}
        </Button>
      ))}
    </Space>
  );
}
